/* eslint-disable no-useless-concat */
//set addSection details
//set welcome page status

import {
  callNotification,
  getAllTemplateFilters,
  getCustomizedDate,
  getUpdatedPredefinedFilter,
  getWidgetGraphObject,
} from "../../constants";
import { setGraphData, setAggregateData } from "../ApiCall";
import moment from "moment";
import { setTemplateBrandObj } from "../Template";
import { setSectionLoader } from "../ApiCall/apiCall";
import {
  setPageChart,
  setWidgetMakerGraphData,
} from "../WidgetMaker/WidgetAPI";
import { setOptionHighChart } from "../HighChart";
import { setGraphBrands } from "../dashboard/Welcome";
import { supportedBenchmarkTraceDashboardTypes } from "../../constants/enums";

export const setSectionDetails = (value) => {
  return { type: "SET_SECTION_KEY", payload: value };
};

export const setEditSectionName = (value) => {
  return { type: "SET_EDIT_SECTION_NAME", payload: value };
};

export const setChangeWidgetOrder = (value) => {
  return { type: "SET_ADDSECTION", payload: value };
};
export const setChangeSectionOrder = (value) => {
  global.Section = value;
  return { type: "SET_ADDSECTION", payload: value };
};
export const setSectionReorderProcessing = (value) => {
  return { type: "SET_SECTION_REORDER_PROCESSING", payload: value };
};
export const setAddSection = (sectionDetails, value, update, newObj) => {
  return (dispatch) => {
    if (!sectionDetails && !value) {
      dispatch({
        type: "SET_ADDSECTION",
        payload: [
          {
            id: null,
            name: null,
            description: null,
            isSectionAdded: false,
            isWidgetAdded: false,
            data: [],
          },
        ],
      });
    } else {
      let indexFound =
        value &&
        sectionDetails?.findIndex((el) => {
          return el.id === value[0]?.id && el?.type !== "predefined";
        });
      const widgetIdMatchData =
        value &&
        sectionDetails?.map((section) =>
          section.id === value[0].id
            ? {
                ...section,
                name: value[0].name ? value[0].name : section.name,
                isWidgetAdded: value[0].isWidgetAdded
                  ? value[0].isWidgetAdded
                  : section?.isWidgetAdded,
                isSectionAdded: value[0].isSectionAdded
                  ? value[0].isSectionAdded
                  : section?.isSectionAdded,
                data: value[0].data ? value[0].data : section?.data,
                description: value[0].description
                  ? value[0].description
                  : section?.description,
                duration: value[0].duration
                  ? value[0].duration
                  : section?.duration,
              }
            : section
        );

      const addSection = update
        ? value
        : indexFound !== -1
        ? widgetIdMatchData
        : sectionDetails?.filter((e) => e?.name !== null).length !== 0
        ? [...sectionDetails, ...value]
        : value;

      if (newObj?.newSection || newObj?.newWidget) {
        let twoMonthsDuration = getCustomizedDate(6, "Days");
        let defaultDuration = {
          from:
            moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
            " " +
            twoMonthsDuration?.time?.startTime,
          to:
            moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
            " " +
            twoMonthsDuration?.time?.endTime,
        };
        let finalDuration;
        let finalBrands;

        //for duration changes
        if (newObj?.newSection && value[0]?.data[0]?.graph_duration) {
          let templateDiff = moment(
            newObj?.templateDetails?.templateDuration?.to
          ).diff(
            moment(newObj?.templateDetails?.templateDuration?.from),
            "days"
          );
          let currentDiff = moment(value[0]?.data[0]?.graph_duration?.to).diff(
            moment(value[0]?.data[0]?.graph_duration?.from),
            "days"
          );

          finalDuration =
            currentDiff > 7
              ? templateDiff > currentDiff
                ? newObj?.templateDetails?.templateDuration
                : value[0]?.data[0]?.graph_duration
              : defaultDuration;
          dispatch(
            setTemplateDetails(newObj?.templateDetails, {
              duration: finalDuration,
            })
          );
        } else if (newObj?.newWidget && newObj?.widgetList[0]?.graph_duration) {
          let templateDiff = moment(
            newObj?.templateDetails?.templateDuration?.to
          ).diff(
            moment(newObj?.templateDetails?.templateDuration?.from),
            "days"
          );
          let currentDiff = moment(
            newObj?.widgetList[0]?.graph_duration?.to
          ).diff(moment(newObj?.widgetList[0]?.graph_duration?.from), "days");
          finalDuration =
            templateDiff >= currentDiff
              ? newObj?.templateDetails?.templateDuration
              : newObj?.widgetList[0]?.graph_duration;
          dispatch(
            setTemplateDetails(newObj?.templateDetails, {
              duration: finalDuration,
            })
          );
        }
        //for brands changes
        if (newObj?.newSection && value[0]?.data[0]?.graph_brands) {
          let templateDiff = newObj?.templateDetails?.templateBrands?.length;
          let currentDiff = value[0]?.data[0]?.graph_brands?.length;

          finalBrands =
            templateDiff > currentDiff
              ? newObj?.templateDetails?.templateBrands
              : value[0]?.data[0]?.graph_brands;

          dispatch(
            setTemplateDetails(newObj?.templateDetails, {
              brands: finalBrands,
            })
          );
        } else if (newObj?.newWidget && newObj?.widgetList[0]?.graph_brands) {
          let templateDiff = newObj?.templateDetails?.templateBrands?.length;
          let currentDiff = newObj?.widgetList[0]?.graph_brands?.length;
          finalBrands =
            templateDiff >= currentDiff
              ? newObj?.templateDetails?.templateBrands
              : newObj?.widgetList[0]?.graph_brands;
          dispatch(
            setTemplateDetails(newObj?.templateDetails, {
              brands: finalBrands,
            })
          );
        }
        let section_index = newObj?.newSection
          ? addSection?.length - 1
          : newObj?.section_index;
        let widget_index = addSection[newObj?.section_index]?.data?.length - 1;

        let templateObj = {
          section: addSection,
          templateDetails: newObj?.templateDetails,
          section_index: section_index,
          widget_index: newObj?.newWidget && widget_index,
          filters:
            newObj?.newWidget && section_index >= 0
              ? addSection[section_index]?.data[widget_index]?.onlyFilters
              : addSection[0]?.data[widget_index]?.onlyFilters,
          authParams: newObj?.authParams,
          global_brands: addSection[section_index]?.is_locked
            ? section_index >= 0
              ? addSection[section_index]?.brandFilters &&
                addSection[section_index]?.brandFilters
              : addSection[0]?.brandFilters
              ? addSection[0]?.brandFilters
              : finalBrands
              ? finalBrands
              : newObj?.global_brands
            : newObj?.templateDetails?.templateBrands?.length > 0 ||
              newObj?.templateDetails?.templateBrands?.columns?.length > 0
            ? finalBrands
              ? finalBrands
              : newObj?.templateDetails?.templateBrands?.columns
              ? newObj?.templateDetails?.templateBrands?.columns
              : newObj?.templateDetails?.templateBrands
            : newObj?.global_brands,
          brands: newObj?.brands,
          brandFilters:
            newObj?.newWidget && section_index >= 0
              ? addSection[section_index]?.data[widget_index]?.brandFilters
              : addSection[0]?.data[widget_index]?.brandFilters,
          dateFilters:
            newObj?.newWidget && section_index >= 0
              ? addSection[section_index]?.data[widget_index]?.dateFilters
              : addSection[0]?.data[widget_index]?.dateFilters,
          duration:
            addSection[section_index]?.is_locked && section_index >= 0
              ? addSection[section_index]?.dateFilters &&
                addSection[section_index]?.dateFilters
              : addSection[0]?.dateFilters
              ? addSection[0]?.dateFilter
              : finalDuration
              ? finalDuration
              : newObj?.templateDetails?.templateDuration,
        };

        let obj = {
          type: "template_section",
          filters: newObj?.global_filters,
          section: addSection,
          brands:
            newObj?.templateDetails?.templateBrands?.length > 0 ||
            newObj?.templateDetails?.templateBrands?.columns?.length > 0
              ? finalBrands
                ? finalBrands
                : newObj?.templateDetails?.templateBrands?.columns
                ? newObj?.templateDetails?.templateBrands?.columns
                : newObj?.templateDetails?.templateBrands
              : newObj?.brands,
          authParams: newObj?.authParams,
          duration: newObj?.templateDetails?.templateDuration
            ? finalDuration
            : null,
          singleBrands: newObj?.singleBrands,
          graphConditionConfig: newObj?.graphConditionConfig,
          newWidgetAdded:
            newObj?.newSection || newObj?.newWidget ? true : false,
        };

        dispatch(setTemplateFilter(obj, templateObj));
        if (
          templateObj?.global_brands?.length > 0 ||
          templateObj?.filters ||
          templateObj?.brandFilters ||
          templateObj?.dateFilters ||
          templateObj?.duration ||
          obj?.filters?.length > 0
        ) {
        }
        if (newObj?.newSection) {
          addSection[0].onlyWidgets = false;
          if (section_index >= 0) addSection[section_index].open = true;
        } else if (newObj?.newWidget) {
          //to open section if new widget is added to a closed section
          addSection[section_index].open = true;
        }
      }
      if (update && update?.sectionUpdate) {
        dispatch(
          setTemplateDetails(
            update?.templateDetails,
            update?.newTemplateDetails
          )
        );
        if (update?.graphDetail && update?.graphBrand) {
          dispatch(setGraphBrands(update?.graphBrand, update?.graphDetail));
        }
        dispatch(setTemplateFilter(update?.template));
      }
      global.Section = addSection;
      dispatch({ type: "SET_ADDSECTION", payload: addSection });
    }
  };
};

export const setEditSectionData = (value) => {
  const sectionData = value?.map((section) => {
    return {
      id: section.id,
      name: section.name,
      isWidgetAdded: section?.isWidgetAdded,
      isSectionAdded: section?.isWidgetAdded,
      data: section?.data,
      description: section?.description,
    };
  });

  return { type: "SET_ADDSECTION", payload: sectionData };
};

export const setDeleteTopic = (sectionDetails, section_id) => {
  let updatedTopics = global.Section
    ? [...global.Section]
    : [...sectionDetails];
  updatedTopics = updatedTopics?.filter((section) => section.id !== section_id);
  global.Section =
    updatedTopics?.length !== 0
      ? updatedTopics
      : [
          {
            id: null,
            name: null,
            description: null,
            isSectionAdded: false,
            isWidgetAdded: false,
            data: [],
          },
        ];

  return {
    type: "SET_ADDSECTION",
    payload:
      updatedTopics?.length !== 0
        ? updatedTopics
        : [
            {
              id: null,
              name: null,
              description: null,
              isSectionAdded: false,
              isWidgetAdded: false,
              data: [],
            },
          ],
  };
};
export const setDuplicateSection = (value) => {
  global.Section = value;
  return { type: "SET_ADDSECTION", payload: value };
};
export const setDeleteWidget = (
  sectionDetails,
  section_id,
  widget_id,
  widget_index,
  isParentOfExplodedWidget
) => {
  let updateSection = global?.Section
    ? [...global.Section]
    : [...sectionDetails];
  let ind = 0;
  const updatedWidgets = updateSection
    ?.find((section) => section?.id === section_id)
    ?.data?.filter((widget, i) => {
      let isExplodeWidgetOfParent = false;
      if (isParentOfExplodedWidget) {
        if (
          (widget_id === widget?.parentId || widget_id === widget?.childId) &&
          ind < isParentOfExplodedWidget?.numberOfCompetitor &&
          i >= widget_index
        ) {
          isExplodeWidgetOfParent = true;
          ind++;
        }
      }
      if (i !== widget_index && !isExplodeWidgetOfParent) {
        return widget;
      }
    });

  const sectionData = updateSection?.map((section) => {
    if (section?.id === section_id) {
      return {
        ...section,
        data: updatedWidgets,
      };
    } else {
      return {
        ...section,
      };
    }
  });
  global.Section = sectionData;
  return { type: "SET_ADDSECTION", payload: sectionData };
};

export const setTemplateDetails = (prevTemplateDetails, value) => {
  let templateDetailsObj = global.template_details
    ? global.template_details
    : prevTemplateDetails;
  let updateTemplateDetails = templateDetailsObj
    ? {
        ...templateDetailsObj,
      }
    : {
        templateName: "",
        templateDescription: "",
        templateDuration: null,
        templateFilters: [],
        templateBrands: [],
        template_type: "",
        dashboard_called_api_list: [],
        advance_duration: [],
        advance_brands: [],
        quick_filter: "",
        private_conversation: true,
        public_engagement_only: false,
        comp_hidden_filter: [],
        hidden_filter: null,
        quick_filter_value: null,
      };
  if (value?.templateName || value?.templateName === "") {
    updateTemplateDetails.templateName = value?.templateName;
  }
  if (value?.templateDescription || value?.templateDescription === "") {
    updateTemplateDetails.templateDescription = value?.templateDescription;
  }
  if (value?.duration) {
    updateTemplateDetails.templateDuration = value?.duration;
  }
  if (value?.advance_duration) {
    updateTemplateDetails.advance_duration = value?.advance_duration;
  }
  if (value?.filters) {
    updateTemplateDetails.templateFilters = value?.filters;
  }
  if (value?.brands) {
    updateTemplateDetails.templateBrands = value?.brands;
  }
  if (value?.advance_brands) {
    updateTemplateDetails.advance_brands = value?.advance_brands;
  }
  if (value?.template_type || value?.template_type === "") {
    updateTemplateDetails.template_type = value?.template_type;
  }
  if (
    value?.competition_aggregation ||
    value?.competition_aggregation === null
  ) {
    updateTemplateDetails.competition_aggregation =
      value?.competition_aggregation;
  }
  if (value?.profileInfo) {
    updateTemplateDetails.profileInfo = value?.profileInfo;
  }
  if (value?.quick_filter) {
    updateTemplateDetails.quick_filter = value?.quick_filter;
  } else if (value?.quick_filter === null) {
    updateTemplateDetails.quick_filter = value?.quick_filter;
  }
  if (value?.dashboard_called_api_list) {
    updateTemplateDetails.dashboard_called_api_list =
      value?.dashboard_called_api_list;
  }
  if (value?.private_conversation || value?.private_conversation === false) {
    updateTemplateDetails.private_conversation = value?.private_conversation;
  }
  if (
    value?.public_engagement_only ||
    value?.public_engagement_only === false
  ) {
    updateTemplateDetails.public_engagement_only =
      value?.public_engagement_only;
  }
  if (value?.comp_hidden_filter) {
    updateTemplateDetails.comp_hidden_filter = value?.comp_hidden_filter;
  }
  if (value?.hidden_filter) {
    updateTemplateDetails.hidden_filter = value?.hidden_filter;
  } else if (value?.hidden_filter === null) {
    updateTemplateDetails.hidden_filter = value?.hidden_filter;
  }
  if (value?.quick_filter_value) {
    updateTemplateDetails.quick_filter_value = value?.quick_filter_value;
  } else if (value?.quick_filter_value === null) {
    updateTemplateDetails.quick_filter_value = value?.quick_filter_value;
  }
  if (value?.adsset_value || value?.adsset_value === null) {
    updateTemplateDetails.adsset_value = value?.adsset_value;
  }
  if (value?.ads_value || value?.ads_value === null) {
    updateTemplateDetails.ads_value = value?.ads_value;
  }
  if (value?.is_brand_locked || value?.is_brand_locked === false) {
    updateTemplateDetails.is_brand_locked = value?.is_brand_locked;
  }
  if (value?.is_date_locked || value?.is_date_locked === false) {
    updateTemplateDetails.is_date_locked = value?.is_date_locked;
  }
  if (value?.profile_filters_list) {
    updateTemplateDetails.profile_filters_list = value?.profile_filters_list;
  } else if (value?.profile_filters_list === null) {
    updateTemplateDetails.profile_filters_list = value?.profile_filters_list;
  }
  global.template_details = updateTemplateDetails;
  return { type: "SET_TEMPLATE_DETAILS", payload: updateTemplateDetails };
};

//set sections detail
export const setSections = (value) => {
  return { type: "SET_SECTIONS", payload: value };
};

//set active section key detail
export const setActiveSectionKey = (value) => {
  return { type: "SET_ACTIVE_SECTION_KEY", payload: value };
};

//whether footer value is Add widget, Add section or Add template
export const setFooterValue = (value) => {
  return { type: "SET_FOOTER_VALUE", payload: value };
};
//set active section key detail
export const setOnSectionFilterIcon = (value) => {
  return { type: "SET_ON_SECTION_FILTER", payload: value };
};

export const setFilterObject = (prevValue, value) => {
  let filterObject;
  if (prevValue) {
    filterObject = {
      ...prevValue,
      is_locked: value ? value : false,
    };
  } else {
    filterObject = value;
  }
  return { type: "SET_FILTER_OBJECT", payload: filterObject };
};

export const setSectionDuration = (templateObj) => {
  let updateSection = [...templateObj?.section];
  updateSection[templateObj?.section_index].dateFilters = templateObj
    ?.durationObj?.from
    ? [
        {
          attribute: "CreatedDate",
          type: "datetime",
          columns: {
            from: templateObj?.durationObj?.from,
            to: templateObj?.durationObj?.to,
          },
        },
      ]
    : null;
  updateSection[templateObj?.section_index].duration = templateObj?.durationObj
    ?.from
    ? templateObj?.durationObj
    : null;
  updateSection[templateObj?.section_index].relative_duration = templateObj
    ?.durationObj?.save_as_relative
    ? {
        is_relative: templateObj?.durationObj?.save_as_relative,
        relative_days: null,
        relative_type: templateObj?.durationObj?.relative?.value,
      }
    : null;
  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
    let obj = {
      type: "template_section",
      section: updateSection,
    };
    dispatch(setTemplateFiltersObj(obj, templateObj));
  };
};

export const setWidgetDuration = (templateObj) => {
  let updateSection = [...templateObj?.section];
  updateSection[templateObj?.section_index].data[
    templateObj?.widget_index
  ].dateFilters = templateObj?.durationObj?.from
    ? [
        {
          attribute: "CreatedDate",
          type: "datetime",
          columns: {
            from: templateObj?.durationObj?.from,
            to: templateObj?.durationObj?.to,
          },
        },
      ]
    : null;
  updateSection[templateObj?.section_index].data[
    templateObj?.widget_index
  ].duration = templateObj?.durationObj ? templateObj?.durationObj : null;

  updateSection[templateObj?.section_index].data[
    templateObj?.widget_index
  ].relative_duration = templateObj?.durationObj?.save_as_relative
    ? {
        is_relative: templateObj?.durationObj?.save_as_relative,
        relative_days: null,
        relative_type: templateObj?.durationObj?.relative?.value,
      }
    : null;

  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
    let obj = {
      type: "template_widget",
      section: updateSection,
    };

    dispatch(setTemplateFiltersObj(obj, templateObj));
  };
};

export const setWidgetSpan = (templateObj) => {
  let updateSection = [...templateObj?.section];
  updateSection[templateObj?.section_index].data[
    templateObj?.widget_index
  ].span = templateObj?.span;

  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
    let obj = {
      type: "template_widget",
      section: updateSection,
    };

    dispatch(setTemplateFiltersObj(obj, templateObj));
  };
};

export const setTemplateSectionFilter = (
  templateObj,
  clear,
  clearBrandAndDuration
) => {
  let dateFilter = Array.isArray(templateObj?.dateFilters)
    ? templateObj?.dateFilters[0]?.columns
    : templateObj?.dateFilters;
  let finalBrands =
    clear || clearBrandAndDuration?.sectionLevelBrand
      ? []
      : templateObj?.brandFilters
      ? [templateObj?.brandFilters]
      : [];
  let finalDates =
    clear || clearBrandAndDuration?.sectionLevelDuration
      ? []
      : templateObj?.dateFilters
      ? [
          {
            attribute: "CreatedDate",
            type: "datetime",
            columns: {
              from: dateFilter?.from,
              to: dateFilter?.to,
            },
          },
        ]
      : [];
  let updateSection = [...templateObj?.section];

  let normalFilter =
    templateObj?.filters?.length > 0
      ? templateObj?.filters
      : updateSection[templateObj?.section_index].onlyFilters?.length > 0
      ? updateSection[templateObj?.section_index].onlyFilters
      : [];

  let finalFilter = templateObj?.is_locked
    ? [...normalFilter]
    : [...normalFilter, ...finalBrands, ...finalDates];

  if (clear) {
    updateSection[templateObj?.section_index].duration = null;
    updateSection[templateObj?.section_index].brands = null;
    updateSection[templateObj?.section_index].profile_filters_list = null;
  }
  if (clearBrandAndDuration?.sectionLevelBrand) {
    updateSection[templateObj?.section_index].brands = null;
  }
  if (clearBrandAndDuration?.sectionLevelDuration) {
    updateSection[templateObj?.section_index].duration = null;
  }
  if (templateObj?.profile_filters_list) {
    updateSection[templateObj?.section_index].profile_filters_list =
      templateObj?.profile_filters_list;
  }
  updateSection[templateObj?.section_index].filters = clear
    ? null
    : finalFilter
    ? finalFilter
    : [];
  updateSection[templateObj?.section_index].onlyFilters = clear
    ? null
    : templateObj?.filters
    ? templateObj?.filters
    : updateSection[templateObj?.section_index].onlyFilters;
  updateSection[templateObj?.section_index].is_locked = clear
    ? false
    : templateObj?.is_locked
    ? templateObj?.is_locked
    : false;
  updateSection[templateObj?.section_index].brandFilters =
    clear || clearBrandAndDuration?.sectionLevelBrand
      ? null
      : templateObj?.brandFilters
      ? templateObj?.brandFilters
      : updateSection[templateObj?.section_index].brandFilters
      ? updateSection[templateObj?.section_index].brandFilters
      : null;
  updateSection[templateObj?.section_index].dateFilters =
    clear || clearBrandAndDuration?.sectionLevelDuration
      ? null
      : templateObj?.dateFilters
      ? templateObj?.dateFilters
      : updateSection[templateObj?.section_index].dateFilters
      ? updateSection[templateObj?.section_index].dateFilters
      : null;
  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
  };
};

export const setTemplateWidgetFilter = (
  templateObj,
  clear,
  clearBrandAndDuration,
  needToBeUpdateSectionAllWidgetsWithId
) => {
  let finalBrands =
    clear || clearBrandAndDuration?.widgetLevelBrand
      ? []
      : templateObj?.brandFilters
      ? templateObj?.brandFilters?.columns?.length
        ? [templateObj?.brandFilters]
        : !templateObj?.brandFilters?.columns
        ? [templateObj?.brandFilters]
        : []
      : [];
  let finalDates =
    clear || clearBrandAndDuration?.widgetLevelDuration
      ? []
      : templateObj?.dateFilters
      ? [
          {
            attribute: "CreatedDate",
            type: "datetime",
            columns: {
              from: templateObj?.dateFilters?.from,
              to: templateObj?.dateFilters?.to,
            },
          },
        ]
      : [];
  let updateSection = [...templateObj?.section];
  if (needToBeUpdateSectionAllWidgetsWithId) {
    updateSection = updateSection?.map((sec, sec_i) => {
      if (sec_i === needToBeUpdateSectionAllWidgetsWithId?.section_index) {
        if (sec?.data && sec?.data?.length > 0) {
          let sectionWidgetObject = [];
          sec?.data &&
            sec?.data?.map((widget) => {
              if (
                needToBeUpdateSectionAllWidgetsWithId?.widget_id ===
                  widget?.parentId ||
                needToBeUpdateSectionAllWidgetsWithId?.widget_id ===
                  widget?.childId ||
                needToBeUpdateSectionAllWidgetsWithId?.widget_id ===
                  widget?.widget_id
              ) {
                let normalFilter =
                  templateObj?.filters?.length === 0 &&
                  templateObj?.filterChange
                    ? []
                    : templateObj?.filters?.length > 0
                    ? templateObj?.filters
                    : widget?.onlyFilters
                    ? widget?.onlyFilters
                    : widget?.filters
                    ? widget?.filters
                    : [];
                normalFilter = Array.isArray(normalFilter)
                  ? normalFilter?.filter(
                      (el) =>
                        el?.attribute !== "BrandID" &&
                        el?.attribute !== "CreatedDate"
                    )
                  : normalFilter;

                let finalFilter = templateObj?.is_locked
                  ? [...normalFilter]
                  : [...normalFilter, ...finalBrands, ...finalDates];

                if (clear) {
                  widget.duration = null;
                  widget.start_date = null;
                  widget.end_date = null;
                  widget.brands = null;
                  widget.profile_filters = null;
                  widget.profile_filters_list = null;
                  widget.profile_filters_flag = null;
                  widget.brand_ids = null;
                  widget.brand_groups = null;
                }
                if (clearBrandAndDuration?.widgetLevelBrand) {
                  widget.brands = null;
                  widget.brand_ids = null;
                  widget.brand_groups = null;
                }
                if (clearBrandAndDuration?.widgetLevelDuration) {
                  widget.duration = null;
                  widget.start_date = null;
                  widget.end_date = null;
                }
                // to update profile_filters key value in section state
                if (templateObj?.profile_filters) {
                  widget.profile_filters = templateObj?.profile_filters;
                }
                if (templateObj?.profile_filters_list) {
                  widget.profile_filters_list =
                    templateObj?.profile_filters_list;
                }
                if (templateObj?.profile_filters_flag) {
                  widget.profile_filters_flag =
                    templateObj?.profile_filters_flag;
                }
                if (templateObj?.brand_ids) {
                  widget.brand_ids = templateObj?.brand_ids;
                }
                if (templateObj?.brand_groups) {
                  widget.brand_groups = templateObj?.brand_groups;
                }

                let widgetFilter = widget?.onlyFilters
                  ? widget?.onlyFilters
                  : widget?.filters
                  ? widget?.filters
                  : [];
                finalFilter = getUpdatedPredefinedFilter(
                  widgetFilter,
                  finalFilter
                );
                widget.filters = clear
                  ? finalFilter?.findIndex((el) => el?.predefined_filters) !==
                    -1
                    ? finalFilter?.filter((el) => el?.predefined_filters)
                    : null
                  : finalFilter;
                widget.onlyFilters = clear
                  ? finalFilter?.findIndex((el) => el?.predefined_filters) !==
                    -1
                    ? finalFilter?.filter((el) => el?.predefined_filters)
                    : null
                  : normalFilter;
                widget.is_locked = clear
                  ? false
                  : templateObj?.is_locked
                  ? templateObj?.is_locked
                  : false;
                widget.brandFilters =
                  clear || clearBrandAndDuration?.widgetLevelBrand
                    ? null
                    : templateObj?.brandFilters
                    ? templateObj?.brandFilters
                    : widget?.brandFilters
                    ? widget?.brandFilters
                    : null;
                widget.dateFilters =
                  clear || clearBrandAndDuration?.widgetLevelDuration
                    ? null
                    : templateObj?.dateFilters
                    ? templateObj?.dateFilters
                    : widget?.dateFilters
                    ? widget?.dateFilters
                    : null;
                if (
                  needToBeUpdateSectionAllWidgetsWithId?.clearDataDurationChanged
                ) {
                  if (
                    widget?.graphData &&
                    !(
                      widget?.type === "rich-content" ||
                      widget?.chart?.chart_type === "text"
                    )
                  ) {
                    delete widget?.graphData;
                  }
                  if (
                    widget?.persist_graphdata &&
                    !(
                      widget?.type === "rich-content" ||
                      widget?.chart?.chart_type === "text"
                    )
                  ) {
                    delete widget?.persist_graphdata;
                  }
                  if (
                    widget?.deep_dive_on &&
                    !(
                      widget?.type === "rich-content" ||
                      widget?.chart?.chart_type === "text"
                    )
                  ) {
                    delete widget?.deep_dive_on;
                  }

                  if (
                    widget?.data &&
                    !(
                      widget?.type === "rich-content" ||
                      widget?.chart?.chart_type === "text"
                    )
                  ) {
                    delete widget?.data;
                  }
                }
                sectionWidgetObject.push(widget);
              } else {
                return sectionWidgetObject.push(widget);
              }
            });
          sec.data = sectionWidgetObject;
          sec.widgets = sectionWidgetObject;
          return sec;
        }
      } else {
        return sec;
      }
    });
  } else {
    if (templateObj?.section_index) {
      let normalFilter =
        templateObj?.filters?.length === 0 && templateObj?.filterChange
          ? []
          : templateObj?.filters?.length > 0
          ? templateObj?.filters
          : updateSection[templateObj?.section_index]?.data[
              templateObj?.widget_index
            ]?.onlyFilters
          ? updateSection[templateObj?.section_index]?.data[
              templateObj?.widget_index
            ]?.onlyFilters
          : updateSection[templateObj?.section_index]?.data[
              templateObj?.widget_index
            ]?.filters
          ? updateSection[templateObj?.section_index]?.data[
              templateObj?.widget_index
            ]?.filters
          : [];
      normalFilter = Array.isArray(normalFilter)
        ? normalFilter?.filter(
            (el) =>
              el?.attribute !== "BrandID" && el?.attribute !== "CreatedDate"
          )
        : normalFilter;

      let finalFilter = templateObj?.is_locked
        ? [...normalFilter]
        : [...normalFilter, ...finalBrands, ...finalDates];

      if (clear) {
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].duration = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].start_date = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].end_date = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].brands = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].profile_filters = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].profile_filters_list = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].profile_filters_flag = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].brand_ids = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].brand_groups = null;
      }
      if (clearBrandAndDuration?.widgetLevelBrand) {
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].brands = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].brand_ids = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].brand_groups = null;
      }
      if (clearBrandAndDuration?.widgetLevelDuration) {
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].duration = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].start_date = null;
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].end_date = null;
      }
      // to update profile_filters key value in section state
      if (templateObj?.profile_filters) {
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].profile_filters = templateObj?.profile_filters;
      }
      if (templateObj?.profile_filters_list) {
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].profile_filters_list = templateObj?.profile_filters_list;
      }
      if (templateObj?.profile_filters_flag) {
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].profile_filters_flag = templateObj?.profile_filters_flag;
      }
      if (templateObj?.brand_ids) {
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].brand_ids = templateObj?.brand_ids;
      }
      if (templateObj?.brand_groups) {
        updateSection[templateObj?.section_index].data[
          templateObj?.widget_index
        ].brand_groups = templateObj?.brand_groups;
      }

      let widgetFilter = updateSection[templateObj?.section_index]?.data?.[
        templateObj?.widget_index
      ]?.onlyFilters
        ? updateSection[templateObj?.section_index]?.data?.[
            templateObj?.widget_index
          ]?.onlyFilters
        : updateSection[templateObj?.section_index]?.data?.[
            templateObj?.widget_index
          ]?.filters
        ? updateSection[templateObj?.section_index]?.data?.[
            templateObj?.widget_index
          ]?.filters
        : [];
      finalFilter = getUpdatedPredefinedFilter(widgetFilter, finalFilter);
      updateSection[templateObj?.section_index].data[
        templateObj?.widget_index
      ].filters = clear
        ? finalFilter?.findIndex((el) => el?.predefined_filters) !== -1
          ? finalFilter?.filter((el) => el?.predefined_filters)
          : null
        : finalFilter;
      updateSection[templateObj?.section_index].data[
        templateObj?.widget_index
      ].onlyFilters = clear
        ? finalFilter?.findIndex((el) => el?.predefined_filters) !== -1
          ? finalFilter?.filter((el) => el?.predefined_filters)
          : null
        : normalFilter;
      updateSection[templateObj?.section_index].data[
        templateObj?.widget_index
      ].is_locked = clear
        ? false
        : templateObj?.is_locked
        ? templateObj?.is_locked
        : false;
      updateSection[templateObj?.section_index].data[
        templateObj?.widget_index
      ].brandFilters =
        clear || clearBrandAndDuration?.widgetLevelBrand
          ? null
          : templateObj?.brandFilters
          ? templateObj?.brandFilters
          : updateSection[templateObj?.section_index]?.data[
              templateObj?.widget_index
            ]?.brandFilters
          ? updateSection[templateObj?.section_index]?.data[
              templateObj?.widget_index
            ]?.brandFilters
          : null;
      updateSection[templateObj?.section_index].data[
        templateObj?.widget_index
      ].dateFilters =
        clear || clearBrandAndDuration?.widgetLevelDuration
          ? null
          : templateObj?.dateFilters
          ? templateObj?.dateFilters
          : updateSection[templateObj?.section_index]?.data[
              templateObj?.widget_index
            ]?.dateFilters
          ? updateSection[templateObj?.section_index]?.data[
              templateObj?.widget_index
            ]?.dateFilters
          : null;
    } else {
      //only widgets
      let normalFilter =
        templateObj?.filters?.length === 0 && templateObj?.filterChange
          ? []
          : templateObj?.filters?.length > 0
          ? templateObj?.filters
          : updateSection[0]?.data[templateObj?.widget_index]?.onlyFilters
          ? updateSection[0]?.data[templateObj?.widget_index]?.onlyFilters
          : updateSection[0]?.data[templateObj?.widget_index]?.filters
          ? updateSection[0]?.data[templateObj?.widget_index]?.filters
          : [];
      normalFilter = Array.isArray(normalFilter)
        ? normalFilter?.filter(
            (el) =>
              el?.attribute !== "BrandID" && el?.attribute !== "CreatedDate"
          )
        : normalFilter;
      let finalFilter = templateObj?.is_locked
        ? [...normalFilter]
        : [...normalFilter, ...finalBrands, ...finalDates];

      if (clear) {
        updateSection[0].data[templateObj?.widget_index].start_date = null;
        updateSection[0].data[templateObj?.widget_index].end_date = null;
        updateSection[0].data[templateObj?.widget_index].duration = null;
        updateSection[0].data[templateObj?.widget_index].brands = null;
        updateSection[0].data[templateObj?.widget_index].profile_filters = null;
        updateSection[0].data[templateObj?.widget_index].profile_filters_list =
          null;
        updateSection[0].data[templateObj?.widget_index].profile_filters_flag =
          null;
        updateSection[0].data[templateObj?.widget_index].brand_ids = null;
        updateSection[0].data[templateObj?.widget_index].brand_groups = null;
      }
      if (clearBrandAndDuration?.widgetLevelBrand) {
        updateSection[0].data[templateObj?.widget_index].brands = null;
        updateSection[0].data[templateObj?.widget_index].brand_ids = null;
        updateSection[0].data[templateObj?.widget_index].brand_groups = null;
      }
      if (clearBrandAndDuration?.widgetLevelDuration) {
        updateSection[0].data[templateObj?.widget_index].start_date = null;
        updateSection[0].data[templateObj?.widget_index].end_date = null;
        updateSection[0].data[templateObj?.widget_index].duration = null;
      }
      // to update profile_filters key value in section state
      if (templateObj?.profile_filters) {
        updateSection[0].data[templateObj?.widget_index].profile_filters =
          templateObj?.profile_filters;
      }
      if (templateObj?.profile_filters_list) {
        updateSection[0].data[templateObj?.widget_index].profile_filters_list =
          templateObj?.profile_filters_list;
      }
      if (templateObj?.profile_filters_flag) {
        updateSection[0].data[templateObj?.widget_index].profile_filters_flag =
          templateObj?.profile_filters_flag;
      }

      if (templateObj?.brand_ids) {
        updateSection[0].data[templateObj?.widget_index].brand_ids =
          templateObj?.brand_ids;
      }
      if (templateObj?.brand_groups) {
        updateSection[0].data[templateObj?.widget_index].brand_groups =
          templateObj?.brand_groups;
      }

      let widgetFilter = updateSection[0]?.data?.[templateObj?.widget_index]
        ?.filters
        ? updateSection[0]?.data?.[templateObj?.widget_index]?.filters
        : updateSection[0]?.data?.[templateObj?.widget_index]?.onlyFilters
        ? updateSection[0]?.data?.[templateObj?.widget_index]?.onlyFilters
        : [];
      finalFilter = getUpdatedPredefinedFilter(widgetFilter, finalFilter);
      updateSection[0].data[templateObj?.widget_index].filters = clear
        ? finalFilter?.findIndex((el) => el?.predefined_filters) !== -1
          ? finalFilter?.filter((el) => el?.predefined_filters)
          : null
        : finalFilter;
      updateSection[0].data[templateObj?.widget_index].onlyFilters = clear
        ? finalFilter?.findIndex((el) => el?.predefined_filters) !== -1
          ? finalFilter?.filter((el) => el?.predefined_filters)
          : null
        : normalFilter;
      updateSection[0].data[templateObj?.widget_index].is_locked = clear
        ? false
        : templateObj?.is_locked
        ? templateObj?.is_locked
        : false;
      updateSection[0].data[templateObj?.widget_index].brandFilters =
        clear || clearBrandAndDuration?.widgetLevelBrand
          ? null
          : templateObj?.brandFilters
          ? templateObj?.brandFilters
          : updateSection[0]?.data[templateObj?.widget_index]?.brandFilters
          ? updateSection[0]?.data[templateObj?.widget_index]?.brandFilters
          : null;
      updateSection[0].data[templateObj?.widget_index].dateFilters =
        clear || clearBrandAndDuration?.widgetLevelDuration
          ? null
          : templateObj?.dateFilters
          ? templateObj?.dateFilters
          : updateSection[0]?.data[templateObj?.widget_index]?.dateFilters
          ? updateSection[0]?.data[templateObj?.widget_index]?.dateFilters
          : null;
    }
  }
  global.Section = updateSection;
  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
  };
};

export const setTemplateSectionBrands = (templateObj) => {
  let updateSection = [...templateObj?.section];

  updateSection[templateObj?.section_index].brands = templateObj?.selectBrands
    ? [templateObj?.selectBrands]
    : null;

  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
    let obj = {
      type: "template_section",
      section: updateSection,
      selectBrands: templateObj?.selectBrands,
      authParams: templateObj?.authParams,
    };

    dispatch(setTemplateBrandObj(obj, templateObj));
  };
};

export const setTemplateWidgetBrands = (templateObj) => {
  let updateSection = [...templateObj?.section];

  updateSection[templateObj?.section_index].data[
    templateObj?.widget_index
  ].brands = templateObj?.selectBrands ? [templateObj?.selectBrands] : null;

  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
    let obj = {
      type: "template_widget",
      section: updateSection,
      selectBrands: templateObj?.selectBrands,
      authParams: templateObj?.authParams,
    };

    dispatch(setTemplateBrandObj(obj, templateObj));
  };
};

export const setTemplateFilter = (sectionObj, templateObj) => {
  return (dispatch) => {
    if (sectionObj?.type === "template_global") {
      // to clear graphData
      setClearWidgetGraphDataInEdit(sectionObj, null, null);

      // Clear profile_filters of all widgets on change of global brands
      // dispatch(setClearProfileFiltersSection(sectionObj?.section));
    } else if (sectionObj?.type === "template_section") {
      // to clear graphData
      if (!sectionObj?.newWidgetAdded) {
        setClearWidgetGraphDataInEdit(
          sectionObj,
          templateObj?.section_index,
          null
        );
      }

      // Clear profile_filters of all widgets on change of global brands
      // dispatch(setClearProfileFiltersSection(sectionObj?.section));
    } else if (sectionObj?.type === "template_widget") {
      let global_brands =
        templateObj?.templateDetails?.templateBrands?.columns?.length > 0
          ? templateObj?.templateDetails?.templateBrands?.columns
          : templateObj?.templateDetails?.templateBrands?.length > 0
          ? templateObj?.templateDetails?.templateBrands
          : templateObj?.global_brands?.columns
          ? templateObj?.global_brands?.columns
          : templateObj?.global_brands?.length > 0
          ? templateObj?.global_brands
          : null;

      let widget = templateObj?.section_index
        ? sectionObj?.section[templateObj?.section_index]?.data[
            templateObj?.widget_index
          ]
        : sectionObj?.section[0]?.data[templateObj?.widget_index];
      delete widget.data;

      //to clear graph data
      let sections = sectionObj?.section;
      let section_index = templateObj?.section_index
        ? templateObj?.section_index
        : 0;
      sections[section_index].data[templateObj.widget_index].data = {
        ...widget,
      };
      sectionObj.quick_filter_value = templateObj?.templateDetails
        ?.quick_filter_value
        ? templateObj?.templateDetails?.quick_filter_value
        : sectionObj?.templateDetails?.quick_filter_value;
      sectionObj.hidden_filter = templateObj?.templateDetails?.hidden_filter
        ? templateObj?.templateDetails?.hidden_filter
        : sectionObj?.templateDetails?.hidden_filter;

      sectionObj.adsset_value = templateObj?.templateDetails?.adsset_value
        ? templateObj?.templateDetails?.adsset_value
        : sectionObj?.templateDetails?.adsset_value;

      sectionObj.ads_value = templateObj?.templateDetails?.ads_value
        ? templateObj?.templateDetails?.ads_value
        : sectionObj?.templateDetails?.ads_value;

      let filter = getAllTemplateFilters(
        sectionObj?.graphConditionConfig,
        sectionObj?.section,
        templateObj?.section_index,
        templateObj?.widget_index,
        sectionObj
      );

      let indexes = {
        section_index: templateObj?.section_index,
        widget_index: templateObj?.widget_index,
        graph_type: widget?.graph_type,
        section: sections,
        templateFilter: true,
        widget_id: widget?.widget_id,
        section_id:
          templateObj?.section_index && templateObj?.section_index >= 0
            ? templateObj?.section?.[templateObj?.section_index]?.id
            : templateObj?.section?.[0]?.id,
        template_details:
          templateObj?.templateDetails && templateObj?.templateDetails,
      };

      let sectionObjN = {
        brandFilters: sections?.[section_index]?.brandFilters
          ? sections?.[section_index]?.brandFilters
          : null,
        filters: sections?.[section_index]?.filters
          ? sections?.[section_index]?.filters
          : [],
        duration: sections?.[section_index]?.duration
          ? sections?.[section_index]?.duration
          : null,
        dateFilters: sections?.[section_index]?.dateFilters
          ? sections?.[section_index]?.dateFilters
          : [],
        is_locked: sections?.[section_index]?.is_locked
          ? sections?.[section_index]?.is_locked
          : false,
        quick_filter_value: templateObj?.templateDetails?.quick_filter_value,
      };
      let widgetObj = {
        filters: widget?.filters ? widget?.filters : [],
        duration: {
          from: widget?.start_date
            ? widget?.start_date
            : widget?.dateFilters?.from
            ? widget?.dateFilters?.from
            : null,
          to: widget?.end_date
            ? widget?.end_date
            : widget?.dateFilters?.to
            ? widget?.dateFilters?.to
            : null,
        },
        is_locked: widget?.is_locked ? widget?.is_locked : false,
      };

      let duration = templateObj?.duration?.from ? templateObj?.duration : null;

      let obj = {};
      obj.section_index = section_index;
      obj.widget_index = templateObj?.widget_index;
      obj.filterChange = sectionObj?.filterChange;

      obj.competition_aggregation =
        supportedBenchmarkTraceDashboardTypes?.includes(
          templateObj?.templateDetails?.template_type
        )
          ? templateObj?.templateDetails?.competition_aggregation || "avg"
          : null;
      obj.template_type = templateObj?.templateDetails?.template_type;
      obj.public_engagement_only =
        templateObj?.templateDetails?.public_engagement_only || false;
      obj.duration = duration;
      obj.global_brands = global_brands;
      obj.filter =
        filter?.length === 0 && sectionObj?.filterChange ? null : filter;
      obj.widget = widget;
      obj.brandlogicalgroup = templateObj?.brands ? templateObj?.brands : null;
      obj.brands = sectionObj?.singleBrands ? sectionObj?.singleBrands : null;
      obj.graphConditionConfig = sectionObj?.graphConditionConfig;
      obj.authParams = templateObj?.authParams;
      obj.sectionObj = sectionObjN;
      obj.widgetObj = widgetObj;
      obj.type = "template";
      obj.profile_filters = templateObj?.profile_filters;
      obj.profile_filters_list = templateObj?.profile_filters_list;
      obj.profile_filters_flag = templateObj?.profile_filters_flag;
      obj.data_source = widget?.data_source ? widget?.data_source : "mentions";
      obj.planned_value = templateObj?.planned_value;

      obj.filter_dropdown = widget?.filter_dropdown
        ? widget?.filter_dropdown
        : [];
      obj.filter_by_dropdown = widget?.filter_by_dropdown
        ? widget?.filter_by_dropdown
        : [];
      obj.filter_by_dropdown_data = widget?.filter_by_dropdown_data
        ? widget?.filter_by_dropdown_data
        : [];

      let widgetGraphObject = getWidgetGraphObject(obj);
      if (widgetGraphObject?.chart?.chart_type === "network-graph-v2") {
        widgetGraphObject.isNetworkChartV2 =
          widgetGraphObject?.chart?.chart_type === "network-graph-v2"
            ? true
            : false;
      }

      let errorMessage =
        "Brand list cannot be empty! Please select atleast one brand.";
      if (widgetGraphObject?.brands?.length > 0) {
        if (
          widgetGraphObject?.x_axis ||
          widgetGraphObject?.y_series ||
          widgetGraphObject?.chart
        ) {
          if (
            sectionObj?.graphConditionConfig?.[`data-source`]?.includes(
              widgetGraphObject?.data_source
            )
          ) {
            dispatch(
              setPageChart(sectionObj?.authParams, widgetGraphObject, indexes)
            );
          } else {
            dispatch(
              setWidgetMakerGraphData(
                sectionObj?.authParams,
                widgetGraphObject,
                indexes
              )
            );
          }
        } else {
          if (sectionObj?.authParams) {
            widgetGraphObject && widgetGraphObject?.graph_type === "aggregate"
              ? dispatch(
                  setAggregateData(
                    widgetGraphObject,
                    indexes //widget data
                  )
                )
              : dispatch(
                  setGraphData(
                    widgetGraphObject,
                    indexes //widget data
                  )
                );
          }
        }
      } else {
        widgetGraphObject && callNotification(errorMessage, "error");
      }
      dispatch(setTemplateBrandObj(null));
      dispatch(setTemplateFiltersObj(null));
    }
    // dispatch(setOptionHighChart(null));
    //dispatch({ type: "SET_GLOBAL_FILTER", panes: updatePanes });
  };
};

export const setClearWidgetGraphDataInEdit = (
  section,
  section_index,
  widget_index
) => {
  let updateSection = global?.Section
    ? [...global.Section]
    : [...section?.section];
  if (section?.type === "template_global") {
    updateSection = updateSection?.map((el, i) => {
      let arr;
      if (
        !el?.is_locked ||
        (el?.is_locked &&
          !el?.duration?.from &&
          section?.change_type === "global_duration") ||
        (el?.is_locked &&
          !el?.brandFilters &&
          section?.change_type === "global_brands")
      ) {
        arr = el?.data?.map((widget, j) => {
          if (
            !(
              widget?.type === "rich-content" ||
              widget?.chart?.chart_type === "text"
            ) &&
            (!widget?.is_locked ||
              (widget?.is_locked &&
                !widget?.duration?.from &&
                section?.change_type === "global_duration") ||
              (widget?.is_locked &&
                !widget?.brandFilters &&
                section?.change_type === "global_brands"))
          ) {
            widget.data = null;
            if (widget?.filter_by_dropdown) {
              widget.filter_by_dropdown = null;
            }
            if (widget?.filter_by_dropdown_data) {
              widget.filter_by_dropdown_data = null;
            }
          }
          delete widget?.widgetSingleBrandFilter;
          return widget;
        });
        el.widgets = arr;
      }

      return el;
    });
  } else if (section?.type === "template_section") {
    let widgets = updateSection?.[section_index]?.data;

    widgets?.forEach((widget, i) => {
      if (
        !widget?.is_locked &&
        !(
          widget?.type === "rich-content" ||
          widget?.chart?.chart_type === "text"
        )
      ) {
        delete widget["data"];
        delete widget?.widgetSingleBrandFilter;
      }
    });

    //to clear graph data
    if (updateSection?.[section_index]) {
      updateSection[section_index].data = [...widgets];
    }
  } else if (widget_index !== null) {
    if (section_index) {
      updateSection[section_index].data[widget_index].data = null;
    } else {
      updateSection[0].data[widget_index].data = null;
    }
  }

  global.Section = updateSection;

  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
  };
};

export const setClearProfileFiltersSection = (Section) => {
  let sections = global.Section ? [...global.Section] : Section;
  let updated_sections_List = sections?.map((el, i) => {
    let arr;
    if (!el?.brands) {
      arr = el?.data?.map((widget, j) => {
        if (widget?.profile_filters_flag && !widget?.is_locked) {
          widget.profile_filters = null;
        }

        return widget;
      });
      el.widgets = arr?.length > 0 ? [...arr] : [];
    }

    return el;
  });

  global.Section = updated_sections_List;

  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updated_sections_List });
  };
};

export const setClearProfileFiltersSectionWidgets = (
  Section,
  section_index
) => {
  let sections = global.Section ? [...global.Section] : Section;

  let updated_section = sections?.[section_index]?.data?.map((widget, j) => {
    if (widget?.profile_filters_flag && !widget?.is_locked) {
      widget.profile_filters = null;
    }

    return widget;
  });

  sections[section_index].data = updated_section;
  global.Section = sections;

  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: sections });
  };
};

export const setTemplateWidgetData = (
  value,
  section,
  section_index,
  widget_index,
  graphObject,
  quickFilterDropdownListInNoData = null
) => {
  let updateSection = global?.Section ? [...global.Section] : [...section];

  if (section_index) {
    // To reset offset value in case of global changes
    if (
      !graphObject?.offset_flag &&
      updateSection?.[section_index]?.data?.[widget_index]?.order_by
    ) {
      updateSection[section_index].data[widget_index].order_by.offset = 0;
    }
    if (updateSection?.[section_index]?.data?.[widget_index]?.profile_filters) {
      updateSection[section_index].data[widget_index].profile_filters =
        graphObject?.profile_filters;
    }
    if (graphObject?.profile_filters) {
      updateSection[section_index].data[widget_index].profile_filters =
        graphObject?.profile_filters;
    }
    updateSection[section_index].data[widget_index].data = value;
    updateSection[section_index].data[
      widget_index
    ].quickFilterDropdownListInNoData =
      quickFilterDropdownListInNoData &&
      Array.isArray(quickFilterDropdownListInNoData)
        ? quickFilterDropdownListInNoData
        : null;
  } else {
    // To reset offset value in case of global changes
    if (
      !graphObject?.offset_flag &&
      updateSection?.[0]?.data?.[widget_index]?.order_by
    ) {
      updateSection[0].data[widget_index].order_by.offset = 0;
    }
    if (updateSection[0].data[widget_index].profile_filters) {
      updateSection[0].data[widget_index].profile_filters =
        graphObject?.profile_filters;
    }
    if (graphObject?.profile_filters) {
      updateSection[0].data[widget_index].profile_filters =
        graphObject?.profile_filters;
    }
    updateSection[0].data[widget_index].data = value;
    updateSection[0].data[widget_index].quickFilterDropdownListInNoData =
      quickFilterDropdownListInNoData &&
      Array.isArray(quickFilterDropdownListInNoData)
        ? quickFilterDropdownListInNoData
        : null;
  }
  // setTimeout(() => {
  //   window.scrollTo(0, window.scrollY + 2);
  // }, 20);
  global.Section = updateSection;
  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
  };
};
export const setClearTemplateWidgetGraphData = (
  section,
  section_index,
  widget_index
) => {
  let updateSection = global?.Section ? [...global.Section] : [...section];
  if (section_index && updateSection?.[section_index]?.data?.[widget_index]) {
    delete updateSection[section_index].data[widget_index].data;
  } else if (updateSection?.[0]?.data?.[widget_index]) {
    delete updateSection[0].data[widget_index].data;
  }
  global.Section = updateSection;

  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
  };
};

export const setTemplateDefaultSortByValueInMetaData = (
  section,
  section_index,
  widget_index,
  defaultValue
) => {
  let updateSection = global?.Section ? [...global.Section] : [...section];
  if (section_index && updateSection?.[section_index]?.data?.[widget_index]) {
    updateSection[section_index].data[widget_index].defaultSortByValue =
      defaultValue;
  } else if (updateSection?.[0]?.data?.[widget_index]) {
    updateSection[0].data[widget_index].defaultSortByValue = defaultValue;
  }
  global.Section = updateSection;

  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
  };
};
export const setTemplateFiltersObj = (sectionObj, templateObj) => {
  let updateObj =
    sectionObj === null
      ? null
      : {
          sectionObj: { ...sectionObj },
          templateObj: { ...templateObj },
        };

  return (dispatch) => {
    dispatch({ type: "SET_TEMPLATE_FILTERS_OBJ", payload: updateObj });
  };
};

export const setIsEditTemplate = (value) => {
  return { type: "SET_EDIT_TEMPLATE", payload: value };
};
export const setEditTemplateWidget = (value, section, section_index) => {
  let updateSection = [...section];
  updateSection[section_index].data = value;
  return (dispatch) => {
    dispatch({ type: "SET_ADDSECTION", payload: updateSection });
  };
};

//set update Widgets Title detail
export const setWidgitTitle = (value, Section, section_index, widget_index) => {
  let updateWidgets = [...Section];

  updateWidgets[section_index].data[widget_index].widget_name = value;
  return { type: "SET_ADDSECTION", payload: updateWidgets };
};

//set update Widgets Title detail
export const setWidgitDescription = (
  value,
  widgetDescRedioStatue,
  Section,
  section_index,
  widget_index
) => {
  let updateWidgets = global?.Section ? [...global.Section] : [...Section];
  updateWidgets[section_index].data[widget_index].widget_description = value;
  updateWidgets[section_index].data[widget_index].widget_description_on_icon =
    widgetDescRedioStatue;
  //updateWidgets[section_index].data[widget_index].widget_description_tooltip = widgetDescRedioStatue;
  //console.log("updateWidgets", updateWidgets);
  global.Section = updateWidgets;
  return { type: "SET_ADDSECTION", payload: updateWidgets };
};
//set active section key detail
export const setSectionDescription = (value, Section, section_index) => {
  let updateWidgets = [...Section];

  updateWidgets[section_index].description = value;

  return { type: "SET_ADDSECTION", payload: updateWidgets };
};
